import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetFileStorageRequest,
  GetFileStorageResponse,
  UpdateFileStorageRequest,
  UpdateFileStorageResponse,
  DeleteFileStorageRequest,
  DeleteFileStorageResponse,
} from "../../models/FileStorage.model";

const API_URL = environment.apiUrl;

/**
 * שליפת רשימת קבצים מהשרת
 */
export const getFileStorage = createAsyncThunk<
  GetFileStorageResponse,
  GetFileStorageRequest,
  { rejectValue: string }
>("fileStorage/getFileStorage", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}FileStorage/GetFileStorage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetFileStorageResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch file storage");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

/**
 * יצירת/עדכון רשומת קובץ בשרת — מקבל בחזרה URL להורדה + Presigned URL
 */
export const updateFileStorage = createAsyncThunk<
  UpdateFileStorageResponse,
  UpdateFileStorageRequest,
  { rejectValue: string }
>(
  "fileStorage/updateFileStorage",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}FileStorage/UpdateFileStorage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateFileStorageResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to update file storage");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

/**
 * מחיקת קובץ מהשרת (DB + S3)
 */
export const deleteFileStorage = createAsyncThunk<
  DeleteFileStorageResponse,
  DeleteFileStorageRequest,
  { rejectValue: string }
>(
  "fileStorage/deleteFileStorage",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}FileStorage/DeleteFileStorage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: DeleteFileStorageResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to delete file storage");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
